import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { DeleteFilled, EditFilled, EyeFilled } from "@ant-design/icons";
import { Auth } from "../../utils/Auth";
import { message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { ClientApi } from "../../api/clientApi";
import { AdminApi } from "../../api/adminsApi";
import Swal from "sweetalert2";

const ListAdminsView = () => {
    const token = Auth.getSessionToken()
    const abortController = new AbortController()
    const [admins, setAdmins] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()


    const handlefetchdata = async () => {
        setLoading(true)

        try {
            const res = await AdminApi.getAdmins(abortController.signal)
 
            if(!res){
                setLoading(false)
                   return;

            }            
            
            console.log("Liste des admins",admins)
            setAdmins(res.data.admins)
            setLoading(false)
 
         } catch (error) {
             console.log(error)
            setLoading(false)
            const messages = await error.messages ?? error.message;

          if(messages instanceof Array)
              return Swal.fire({
                title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                icon:"error",
              }).then((result) => {
                Auth.removeSessionToken()
                return navigate(`/login`)			
              });
 
         }
    }

    const handleDetail = (admin) => {
        console.log("ID mecano",admin.id)
        if(admin.id)
            return navigate(`/gestion-admins/${admin.id}/details`)
        
    }


    const handleEdit =(admin) => {
      if(admin.id)
        return navigate(`/gestion-admins/${admin.id}/edit`)
    }
    const handleDelete = async (admin) => {
        try {
          const res = await ClientApi.deleteProvider(`${admin.id}`,abortController.signal)

          if (res) {
            message.success("Les informations ont été mises à jour avec succès !");
          }

          handlefetchdata()
          
        } catch (error) {
          console.error(error);
          setLoading(false);
          message.error("Échec de suppression des informations");
        }
        
        

    }

    const handleAddAdmin = () => {
      navigate('/gestion-admins/create')
    }

    useEffect(() => {
        handlefetchdata()

        console.log('liste get token',token)
    },[])

  return (
    <MainLayout>
      <div className="container mx-auto p-4">
        <h1 className="text-xl font-bold mb-4">Liste des admins</h1>

        {/* Bouton Ajouter */}
        <button
          onClick={handleAddAdmin}
          className="mb-4 px-4 py-2 text-white bg-africasa-secondary rounded hover:bg-africasa-primary"
        >
          Ajouter un admin
        </button>

        {/* Table */}
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="py-2 px-4 border-b text-left">#</th>
              <th className="py-2 px-4 border-b text-left">Photo</th>
              <th className="py-2 px-4 border-b text-left">Nom et prenoms</th>
              <th className="py-2 px-4 border-b text-left">Email</th>
              <th className="py-2 px-4 border-b text-left">Niveau de permission</th>
              <th className="py-2 px-4 border-b text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
                <tr>
                <td colSpan="6" className="text-sm text-center py-4">
                    Chargement des données en cours...
                </td>
                </tr>
            ) : (
                admins.map((admin, index) => (
                <tr key={admin.id}>
                    <td className="py-2 px-4 border-b">{index + 1}</td>
                    <td className="py-2 px-4 border-b"><img src={`http://localhost:8000`+admin?.profil_pic} className="w-10 h-10"/></td>
                    <td className="py-2 px-4 border-b">
                    {admin?.name} {admin?.lastname}
                    </td>
                    <td className="py-2 px-4 border-b">{admin?.email}</td>
                    <td className="py-2 px-4 border-b">{admin?.role_id}</td>
                    <td className="py-2 px-4 border-b">
                    <EyeFilled
                        className="text-green-600 mr-2 cursor-pointer hover:text-green-800"
                        onClick={() => handleDetail(admin)}
                    />
                    <EditFilled className="text-blue-600 mr-2 cursor-pointer hover:text-blue-800" 
                      onClick={() => handleEdit(admin) }

                    />
                    <DeleteFilled className="text-red-600 cursor-pointer hover:text-red-800"
                      onClick={() => handleDelete(admin)}
                    />
                    </td>
                </tr>
                ))
            )}
            </tbody>

        </table>
      </div>
    </MainLayout>
  );
};

export default ListAdminsView;
